var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 426.94 244.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d8d8d8;}.cls-2{fill:#f9f9f9;}.cls-3{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cloud3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.05,190.72c-1.8,0-3.6,0-5.34.08a73.74,73.74,0,0,0-71.27-62.66,73,73,0,0,0-44.56,13.93,77.47,77.47,0,0,0-145.69,35.36,69.49,69.49,0,0,0,.25,8c-1.73-.16-3.53-.25-5.32-.29A77.71,77.71,0,0,0,100,340.58l271.93,5.53a77.71,77.71,0,0,0,3.17-155.39Z",
    transform: "translate(-24.03 -101.29)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M218.34,119.18a74.8,74.8,0,0,0-99,69.46,66.18,66.18,0,0,0,.26,7.76c-1.67-.16-3.41-.25-5.15-.29a75,75,0,0,0-67.14,111c-2.18-33.86,4.28-98.36,85.09-95.15C132,189.86,137.38,120.71,218.34,119.18Z",
    transform: "translate(-24.03 -101.29)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.44,341.34l234.44,4.77A77.58,77.58,0,0,0,451,270a78.81,78.81,0,0,0-4-26.21C394,343.38,221.88,330.93,137.44,341.34Z",
    transform: "translate(-24.03 -101.29)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud3);
export default __webpack_public_path__ + "static/media/cloud3.448bc45e334a27c5ced2b200f0cb6bf4.svg";
export { ForwardRef as ReactComponent };